import React, { Suspense, lazy, useEffect } from 'react';
import Hero from "../hero/Hero";
import Article from "../article/Article";
import Resources from "../resources/Resources";
import {FaRegFilePdf} from "react-icons/fa";
import {Helmet} from "react-helmet";
import ContactForm from "../contact-form/ContactForm";
import { StyledPageStandardSection } from './styled'
import Placeholder from '../generic/Placeholder';
import { scrollToElement } from '../../utilities/index';
import { Link } from "react-router-dom";

const Features = lazy(() => import("../features/Features"))




const Pageoffice365more = () => {
    return (
        <>
            <Helmet>
                <title>Mailwall Office 365 Email Protection Benefits and Features</title>
                <meta name="description" content="Omniquad’s Spear Phishing Safety Assessment Subscription service audits that end users are aware of spear phishing risks and would not give confidential information when exposed to spear phishing"/>
            </Helmet>
            <main className={"Page office-features"}>
                <Hero>
                    <h1>Mailwall Office 365 Benefits and Features</h1>
                </Hero>

                <Article>
				
					<StyledPageStandardSection>
						<Link className="Backtohome" to={`/office365`} title='PRICING' onClick={scrollToElement}>&lt;&lt; Back to Mailwall Office 365</Link>
					</StyledPageStandardSection>
					
                    <StyledPageStandardSection>
						<img src="resources/icons/svg/security.svg" width="250"/>
						<p>
                        <h2>
                            Outlook and Mailwall Office 365 Protection
                        </h2>
                        <ul>
                            <li> Protect confidentiality, integrity, and availability of your email with Omniquad Mailwall </li>
							<li> Up to 30 days rolling email continuity for all users by default regardless of your primary email system availability </li>
							<li> Business Continuity is critical for any migration </li>
							<li> Enable your business to move faster </li>
							<li> Easily integrate with Office 365 out of the box </li>
							<li> Reduce the number of internal IT support cases with self-service email retrieval features </li>
							<li> Delete archive data retrieval to authorized users only </li>
							<li> Block diverse threats such as malware, ransomware, phishing, and identity attacks </li>
							<li> Guarantee uninterrupted mail access for your users in event mail availability issues during or post-migration </li>
							<li> Our datacenters deliver leading class security and compliance requirements in the cloud </li>
						</ul>
						</p>

                    </StyledPageStandardSection>
					
					<StyledPageStandardSection>
					
						<img src="resources/icons/svg/recovery.svg" width="250"/>
						<p>
						<h2>Enterprise Email Branding</h2>
                        <ul>
                            <li>Add an extra layer of protection for your end-users with Sandboxing that physically separates previewed content from their environment. Such a secure enclave makes it impossible for threats to spread due to running in a different security context.		
							Safeguard your brand from supply chain attacks, compromised accounts used by your business partners and attempts to impersonate your employees through spoofing or similar sounding names.</li>
							<li>Implement an "Assume Breach" security mindset and look for signs of compromise inside internal communications rather than implicitly trusting the firewall network permitter.</li>
						</ul>
									</p>		

                    </StyledPageStandardSection>
					
					<StyledPageStandardSection>
					
						<img src="resources/icons/svg/phishwise.svg" width="250"/>
						<p>
                        <h2>AI in Cybersecurity</h2>
                        <ul>
							<li>Mailwall lets you analyze threats intelligence information in the built-in lightweight SIEM or will integrate with your own solution. You can then further integrate with your SOC for appropriate response.</li>				
							<li>Protect from data exfiltration threats with intelligent Data Loss Prevention features that can recognize Personally Identifiable Information, social security numbers, credit card numbers, or other sensitive data.</li>					
							<li>By using multi-layered defense in depth on top of your Office 365 plan, you will block threats that make their way into your Office 365 tenant.</li>					
							<li>Recover missed or deleted emails directly into user mailboxes, regardless of whether outages occurred before or after they are received.</li>					
							<li>AI-backed machine learning and threat analytics in Omniquad Mailwall take protection to the next level by understanding and modeling both user and attacker behavior. Even subtle changes in writing style are factored in AI training datasets.</li>
						</ul>
							</p>	

                    </StyledPageStandardSection>
					
					<Suspense fallback={<Placeholder />}>
							<Features dataFile="featuresOffice365Databenefits.js" />
						</Suspense>	
					
					<StyledPageStandardSection>
						<img src="resources/icons/svg/smartl_list.svg" width="250"/>
						<p>
						<h2>Protect from Cybercriminals</h2>
						<ul>
							<li>Many Office 365 customers require better protection by what is provided as standard in Exchange Online Protection in Office 365. Businesses today are concerned with diverse types of threats that target users’ identities with phishing, whaling, and impersonation attacks.</li>
							<li>Most targeted attacks are email-based so protection against social engineering attempts needs to be detected before misplaced trust is established.</li>
							<li>Prevent Business Email Compromise (BEC). Attackers often impersonate parties your users may be familiar with, and these are among the most dangerous because the attackers can end up being trusted.</li>
							<li>Deploy machine learning assisted fraud detection to block highly sophisticated impersonation attacks</li>
							<li>Deep content analysis - from IP analysis through headers, message content, URLs, and even the style of writing is used by our algorithms to detect business email compromise attacks. The message URLs are scanned with dynamically provisioned sandbox systems that analyze the behavior of clicking on links.</li>
							<li>Attackers can go to great lengths to research your business if it is a viable target - public details as public officers or company Director's names are readily available. They will then craft highly tailored messages to maximize their chance of gaining trust.</li>
							<li>BEC attacks may target anyone -the accounting team, company directors, or your suppliers. These are difficult to be spotted by users and are on the increase.</li>
							<li>A BEC attack does not have to necessarily aim at funds transfer, it can be a part of a more sophisticated operation to obtain other valuable data.</li>
							<li>Phishing attacks today are highly sophisticated - for example, Business Email Compromise (BEC) attacks that arrive from compromised accounts of companies you trade with. The attacker will swap bank account details. You need a solution that will help spot such anomalies in day-to-day Business as Usual.</li>
							<li>Attackers have unlimited time to keep trying to find loopholes until they succeed, and will keep trying to reach different individuals or departments. And while traditional methods include malware in attachments, more and more attacks focus on targeting or spoofing identifies.</li>
							<li>A single data breach incident can cause irreparable damage to your brand and expose your business to financial losses through loss of customer confidence or data protection legislation fines.</li>								
						</ul>
						</p>
						

                    </StyledPageStandardSection>
					
					<StyledPageStandardSection>
						<img src="resources/icons/svg/report.svg" width="250"/>
						<p>
						<h2>Omniquad Mailwall vs. Microsoft 365 Security</h2>
						<ul>
							<li>Extend protection to your users beyond what Microsoft provides in Office 365.</li>
							<li>Layered security on top of Office 365 is essential to protect your business against unknown threats. Using more than one vendor for protection gives you a safeguard of multilayered defense.</li>
							<li>Do not depend on single vendor for all your security needs.</li>
							<li>With majority of zero-day threats penetrating enterprise by email, the importance of cyber kill chain is now a critical consideration to almost every business. A single email that sneaks through security perimeter can lead to major data breach. Many IT managers find that built-in security features in Office 365 do not match the level of protection provied by dedicated security vendors.</li>
							<li>As businesses accelerate cloud adoption due to the Pandemic, they face challenge how to address new risks</li>
						</ul>
						</p>

                    </StyledPageStandardSection>
					
					<StyledPageStandardSection>
						<img src="resources/icons/svg/management_reports.svg" width="250"/>
						<p>
						<h2>It just works better</h2>
						<ul>
							<li>Customers using Mailwall for Office 365 say they benefit from significantly better level of protection than Office 365 can provide on their own.</li>
							<li>Surveys of Microsoft Office 365 customers highlight the need for higher level of protection than provided by default. This applies the entire set of capabilities delivered by the email protection platform – from ransomware through phasing and impersonation attacks. Dedicated vendors have more experience in this area and offer greater protection coverage as this is their core expertise.</li>
						</ul>
						</p>

                    </StyledPageStandardSection>
					
					<StyledPageStandardSection>
						<Link className="Backtohome" to={`/office365`} title='PRICING' onClick={scrollToElement}>&lt;&lt; Back to Mailwall Office 365</Link>
					</StyledPageStandardSection>
					
					
					
                </Article>
            </main>
        </>
    )
}

export default Pageoffice365more;
